import { render, staticRenderFns } from "./PartnerMeterLimit.vue?vue&type=template&id=0524af10&scoped=true&"
import script from "./PartnerMeterLimit.vue?vue&type=script&lang=js&"
export * from "./PartnerMeterLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524af10",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/partner/sections/PartnerMeterLimit.vue
// module id = 1512
// module chunks = 0